module.exports = __webpack_public_path__ + "static/media/website-security-management1.cd44110d.png";